import { useTranslation } from "react-i18next";
import { Tag } from "../../Tag/Tag";
import "../../../../../i18n/i18n";
import { colorTagProps } from "./colorTagProps";

type HomeChargingConnectionStatus =
  | "PENDING"
  | "CONNECTED"
  | "ERROR"
  | "DEACTIVATED";
const connectionStatusEnum = ["PENDING", "CONNECTED", "ERROR", "DEACTIVATED"];

const connectionStatusProps: Record<
  HomeChargingConnectionStatus,
  (typeof colorTagProps)[keyof typeof colorTagProps]
> = {
  PENDING: colorTagProps.informative,
  CONNECTED: colorTagProps.success,
  ERROR: colorTagProps.error,
  DEACTIVATED: colorTagProps.neutral,
};

export const TableTagHomeChargingConnectionStatus = (props: {
  status: string;
}) => {
  const { t } = useTranslation();
  const statusTranslated = connectionStatusEnum.find(
    (status) => t(`home_charging.connectionStatus.${status}`) === props.status,
  );
  if (!statusTranslated) {
    return null;
  }
  const render =
    connectionStatusProps[statusTranslated as HomeChargingConnectionStatus];

  return (
    <Tag
      text={props.status}
      backgroundColor={render.backgroundColor}
      textColor={render.textColor}
      iconColor={render.iconColor}
    />
  );
};
